"use client";

import React from "react";
import styled from "styled-components";
import { dayjs } from "@lib/client";

/**
 * 発送メッセージ履歴用テーブル（haiso_message_list.ctp の table.normal.order_info に合わせたデザイン）
 * PHP: ordered_base.css table.normal + ordered_contents.css table.order_info
 */
const HaisoMessageTable = styled.table`
  width: 100%;
  margin: 15px 0;
  text-align: center;
  font-size: 14px;
  color: #333;
  border-collapse: collapse;
  border-spacing: 0;

  th,
  td {
    border: 1px solid #333;
    padding: 8px 2px;
  }
  th {
    background: #ffbcbc;
    font-weight: bold;
  }
  td {
    background: #fff;
  }
  caption {
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
  }
`;

/** table.order_info .left 相当 */
const HaisoMessageTh = styled.th`
  width: 200px;
  text-align: left !important;
  padding-left: 5px !important;
  vertical-align: top;
`;

const HaisoMessageTd = styled.td`
  text-align: left !important;
  padding-left: 5px !important;
  white-space: pre-line;
`;

/**
 * 発送メッセージ履歴コンポーネント
 * PHP: htdocs_yz/app/views/elements/ordereddetail/haiso_message_list.ctp のデザインを反映
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Array} props.hmData - 発送メッセージ履歴データの配列
 * @returns {JSX.Element} 発送メッセージ履歴コンポーネント
 */
export default function HaisoMessage({ hmData = [] }) {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = dayjs(dateString);
    if (!d.isValid()) return "";
    return d.format("YYYY年M月D日 HH:mm");
  };

  if (!Array.isArray(hmData) || hmData.length === 0) {
    return null;
  }

  return (
    <HaisoMessageTable>
      <caption>発送メッセージ履歴</caption>
      <tbody>
        {hmData.map((hm, index) => {
          const created = hm?.created ?? hm?.HaisoMessage?.created;
          const partsName = hm?.PartsName ?? hm?.HaisoMessage?.PartsName ?? "";
          const message = hm?.Message ?? hm?.HaisoMessage?.Message ?? "";

          return (
            <React.Fragment key={index}>
              <tr>
                <HaisoMessageTh scope="row">
                  発送登録日時：{formatDate(created)}　　部品名：{partsName}
                </HaisoMessageTh>
              </tr>
              <tr>
                <HaisoMessageTd>{message}</HaisoMessageTd>
              </tr>
            </React.Fragment>
          );
        })}
      </tbody>
    </HaisoMessageTable>
  );
}
